import { render } from "./AddEdgeDeviceView.vue?vue&type=template&id=519a8104&scoped=true"
import script from "./AddEdgeDeviceView.vue?vue&type=script&lang=js"
export * from "./AddEdgeDeviceView.vue?vue&type=script&lang=js"

import "./AddEdgeDeviceView.vue?vue&type=style&index=0&id=519a8104&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519a8104"]])

export default __exports__